import type { Ref } from 'vue'
import { Row as VanRow, Col as VanCol, Dialog as VanDialog } from 'vant'
import type { TukuVoteSummary } from '@/api'

/** 一个生肖投票选项（rate 是百分号前的数值，如 12.5 表示 12.5%） */
export interface ZodiacVoteOption {
  animalId: number
  animalName: string
  rate: number
  voteCount: number
}

// 12 生肖兜底（图库投票 summary 加载前使用）
const TUKU_ZODIAC_FALLBACK: ZodiacVoteOption[] = [
  '鼠', '牛', '虎', '兔', '龙', '蛇', '马', '羊', '猴', '鸡', '狗', '猪',
].map((name, i) => ({ animalId: i + 1, animalName: name, rate: 0, voteCount: 0 }))

/** 图库投票 summary → 投票选项；summary 为空时返回 12 生肖 0 票 */
export function toTukuVoteOptions(summary: TukuVoteSummary | null): ZodiacVoteOption[] {
  const list = summary?.animals ?? []
  if (list.length === 0) return TUKU_ZODIAC_FALLBACK
  return list.map((v) => ({
    animalId: v.animal_id ?? 0,
    animalName: v.animal_name ?? '',
    rate: Number.parseFloat(v.rate ?? '0'),
    voteCount: v.vote_count ?? 0,
  }))
}

/** 图库各生肖票数 + 进度条（49208 .ms-bd-vote），图库详情与投票记录页共用 */
export function renderTukuVoteGrid(list: ZodiacVoteOption[]) {
  return (
    <div class="ms-bd-vote">
      <VanRow gutter={15}>
        {list.map((item) => (
          <VanCol key={item.animalId} span={12}>
            <div class="vote-num">{item.voteCount}票</div>
            <div class="vote-item">
              <span class="left">{item.animalName}</span>
              <div class="bd-rate">
                <span class="bd-rate-color" style={{ width: `${item.rate}%` }} />
              </div>
              <span class="right">{item.rate.toFixed(2)}%</span>
            </div>
          </VanCol>
        ))}
      </VanRow>
    </div>
  )
}

/** 「选择投票」弹窗：点选生肖写入 selected，点「投票」触发 onConfirm */
export function renderZodiacVoteDialog(opts: {
  show: Ref<boolean>
  selected: Ref<number | null>
  list: ZodiacVoteOption[]
  onConfirm: () => void
}) {
  const { show, selected } = opts
  return (
    <VanDialog
      v-model:show={show.value}
      title="选择投票"
      confirmButtonColor="#07c160"
      confirmButtonText="投票"
      closeOnClickOverlay
      onConfirm={opts.onConfirm}
    >
      <div class="dialog-set-vote">
        <VanRow gutter={10}>
          {opts.list.map((item) => (
            <VanCol key={item.animalId} span={6} onClick={() => (selected.value = item.animalId)}>
              <div class={['item', { act: item.animalId === selected.value }]}>
                {item.animalName}
                <div>{item.voteCount}票</div>
              </div>
            </VanCol>
          ))}
        </VanRow>
      </div>
    </VanDialog>
  )
}
